<template>

    <div class="md:px-3">

        <div class="flex items-center cursor-pointer hover:bg-indigo-600 bg-indigo-500 ml-2 px-5 py-3 rounded-xl transition-colors text-white"
             v-on:click="openModal">

            <svg xmlns="http://www.w3.org/2000/svg" width="21.156" height="21.156"
                 class="h-4 md:h-6"
                 viewBox="0 0 21.156 21.156"
            >
                <g id="Group_162" data-name="Group 162">
                    <g id="Group_161" data-name="Group 161">
                        <path id="Path_35" data-name="Path 35"
                              d="M9.317,0a9.317,9.317,0,1,0,9.317,9.317A9.327,9.327,0,0,0,9.317,0Zm0,16.913a7.6,7.6,0,1,1,7.6-7.6A7.605,7.605,0,0,1,9.317,16.913Z"
                              fill="currentColor"/>
                    </g>
                </g>
                <g id="Group_164" data-name="Group 164" transform="translate(14.505 14.505)">
                    <g id="Group_163" data-name="Group 163">
                        <path id="Path_36" data-name="Path 36"
                              d="M357.444,356.228l-4.931-4.931a.86.86,0,0,0-1.216,1.216l4.931,4.931a.86.86,0,0,0,1.216-1.216Z"
                              transform="translate(-351.046 -351.046)" fill="currentColor"
                        />
                    </g>
                </g>
            </svg>

            <span class="ml-3 hidden md:inline">Zoeken</span>

        </div>

        <div v-show="showModal"
             @click="closeModalIfNotInput($event)"
             class="fixed z-50 inset-0 overflow-y-auto bg-gray-500 bg-opacity-75"
             aria-labelledby="modal-title"
             role="dialog"
             aria-modal="true"
             style="-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);"
        >

            <div class="flex items-start justify-center min-h-screen p-4 text-center">

<!--                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>-->

                <div
                    class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-top mt-10 lg:mt-16 xl:mt-24 2xl:mt-40 sm:max-w-4xl sm:w-full">

                    <div>
                        <div class="relative rounded-md">
                            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                            <input
                                type="text"
                                ref="searchTermInput"
                                placeholder="Typ hier uw zoekterm..."
                                v-model="searchTerm"
                                class="shadow-sm ring-0 border-0 block w-full border-gray-300 py-3 pl-12 pr-6"
                                @keydown.up.prevent="selectPrevResult"
                                @keydown.down.prevent="selectNextResult"
                                @keydown.enter.prevent="goToCurrentResultIndex"
                                @keydown.esc.prevent="closeModal"
                            />
                        </div>
                    </div>

                    <div>
                        <ul v-for="(result, index) in results"
                            :key="index"
                            class="text-sm font-medium overflow-y-auto border-t border-gray-200 divide-y divide-gray-200">

                            <li>
                                <a :href="result.url"
                                   class="flex justify-between p-4 transition-all duration-75"
                                   @mouseover="selectedResultIndex = index"
                                   :class="[index === selectedResultIndex ? 'bg-indigo-500 text-white' : 'bg-gray-50 text-gray-800']">

                                    <span class="truncate pr-5">
                                        {{ result.title }}
                                    </span>

                                    <span>
                                        {{ result.model }}
                                    </span>

                                </a>

                            </li>

                        </ul>

                        <ul v-if="this.noResults" class="text-sm font-medium overflow-y-auto border-t border-gray-200 divide-y divide-gray-200">
                            <li>
                                <span class="flex justify-center p-4 transition-all duration-75 bg-gray-50 text-gray-500">Geen zoekresultaten gevonden</span>
                            </li>
                        </ul>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";
import hotkeys from 'hotkeys-js';

export default {

    data: () => {
        return {
            showModal: false,
            searchTerm: '',
            results: [],
            selectedResultIndex: 0,
            noResults: false,
        }
    },

    mounted: function () {
        hotkeys.filter = function(event){
            return true;
        }

        // todo: set hotkeys-js scope
        hotkeys('ctrl+k, command+k', () => {
            if (!this.showModal) {
                this.openModal();
            } else {
                this.closeModal();
            }
        });
    },

    computed: {},

    watch: {
        searchTerm(newVal, oldVal) {
            if (newVal === '') {
                this.results = [];
            } else {
                this.search(newVal);
            }
        }
    },

    methods: {

        openModal() {
            this.showModal = true;

            // Focussing the element must be done after the nextTick, so Vue has time to append the element to the DOM
            this.$nextTick(() => this.$refs.searchTermInput.focus())

        },

        closeModal() {
            this.showModal = false;
            this.searchTerm = '';
            this.results = [];
        },

        closeModalIfNotInput(event) {
            if ($(event.target).is('input')) {
                return;
            }

            this.closeModal();
        },

        selectPrevResult() {
            this.selectedResultIndex = Math.max(0, this.selectedResultIndex - 1);
        },

        selectNextResult() {
            this.selectedResultIndex = Math.min(this.results.length - 1, this.selectedResultIndex + 1);
        },

        goToCurrentResultIndex() {
            if(this.results[this.selectedResultIndex]) {
                window.location.href = this.results[this.selectedResultIndex].url;
            }
        },

        async search(term) {
            this.selectedResultIndex = 0;
            let dataPrefix = $('html').data('prefix');

            await axios.get('/' + (dataPrefix !== undefined ? dataPrefix : 'admin/') + 'search/?term=' + term).then(response => {
                    this.results = response.data
                }
            );

            this.noResults = this.searchTerm !== '' && this.results.length === 0;
        }
    }

}

</script>
